var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length)?_c('div',_vm._l((_vm.errors),function(error){return _c('Nl2Br',{key:error,attrs:{"text":_vm.getValueByKey(error, _vm.jsonKey),"tag":"small","class-name":"text-danger"}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }